"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMoreParams = void 0;
var lodash_1 = require("lodash");
var fetchMoreParams = function (state, items, resultKey, isReverse) {
  return {
    /*
    NB: using items.length in `skip` here advances the cursor, as the
    length continues to grow as more results are fetched
    
    Also, IF THIS DOESN'T WORK, ENSURE YOU HAVE "notifyOnNetworkStatusChange: true" in your query options!!
    */
    variables: __assign(__assign({}, state), {
      skip: items.length
    }),
    updateQuery: function (prev, _a) {
      // console.log("PREV", prev);
      // console.log("FETCH MORE RESULT", fetchMoreResult);
      var _b;
      var fetchMoreResult = _a.fetchMoreResult;
      if (!fetchMoreResult) return prev;
      var resultPrev = (0, lodash_1.get)(prev, resultKey, {
        results: []
      });
      var result = (0, lodash_1.get)(fetchMoreResult, resultKey, {
        results: []
      });
      var newResult = (_b = {}, _b[resultKey] = __assign(__assign({}, resultPrev), {
        results: isReverse ? __spreadArray(__spreadArray([], __read(result.results), false), __read(items), false) : __spreadArray(__spreadArray([], __read(items), false), __read(result.results), false)
      }), _b);
      // console.log("NEW RESULT", newResult);
      return newResult;
    }
  };
};
exports.fetchMoreParams = fetchMoreParams;